import Observe, { AppMetrics } from 'expo-observe';

import { env } from 'utils/environment';

type ObserveConfig = {
  environment?: string;
  dispatchInDebug?: boolean;
};

type ObserveModule = {
  configure(config: ObserveConfig): void;
};

type AppMetricsAttributes = {
  routeName?: string;
  params?: Record<string, unknown>;
};

type AppMetricsModule = {
  markInteractive(attributes?: AppMetricsAttributes): void | Promise<void>;
};

const observeModule = (Observe as unknown) as ObserveModule;
const appMetricsModule = (AppMetrics as unknown) as AppMetricsModule;

let isConfigured = false;
let hasMarkedInteractive = false;

const shouldDispatchInDebug = () =>
  process.env.EXPO_PUBLIC_EAS_OBSERVE_DISPATCH_IN_DEBUG === 'true' ||
  process.env.REACT_APP_EAS_OBSERVE_DISPATCH_IN_DEBUG === 'true';

export const configureEasObserve = () => {
  if (isConfigured) {
    return;
  }

  observeModule.configure({
    environment: env(),
    dispatchInDebug: shouldDispatchInDebug(),
  });

  isConfigured = true;
};

export const markEasObserveInteractiveOnce = (attributes?: AppMetricsAttributes) => {
  if (hasMarkedInteractive) {
    return;
  }

  configureEasObserve();
  hasMarkedInteractive = true;
  void appMetricsModule.markInteractive(attributes);
};
